const t = "dates-container";
export {
  t as DATES_CONTAINER
};
